/* <living-proof> — the in-grid "claim → proof" card. Picks a random trust
   statement + a random verified review on each connect, so the card is almost
   never the same twice (per visit AND per filter, since the grid re-renders on
   facet changes). Data is embedded as JSON; randomization is client-side so it
   works even behind full-page caching. Mirrors the homepage hero-prime pattern. */
if (!customElements.get('living-proof')) {
  customElements.define(
    'living-proof',
    class LivingProof extends HTMLElement {
      connectedCallback() {
        try {
          this.trust = JSON.parse(this.dataAt('[data-lp-trust]') || '[]');
          this.reviews = JSON.parse(this.dataAt('[data-lp-reviews]') || '[]');
        } catch (e) {
          return; // leave the server-rendered fallback pair in place
        }
        this.render();
      }

      dataAt(sel) {
        const el = this.querySelector(sel);
        return el ? el.textContent : '';
      }

      pick(arr) {
        return arr && arr.length ? arr[Math.floor(Math.random() * arr.length)] : null;
      }

      setText(sel, val) {
        const el = this.querySelector(sel);
        if (el && val != null) el.textContent = val;
      }

      render() {
        const t = this.pick(this.trust);
        if (t) {
          this.setText('[data-lp-h]', t.h);
          this.setText('[data-lp-s]', t.s);
          const sub = this.querySelector('[data-lp-s]');
          if (sub) sub.hidden = !t.s;
        }

        const r = this.pick(this.reviews);
        const proof = this.querySelector('.lp__proof');
        if (!proof) return;
        if (!r) {
          proof.hidden = true;
          this.classList.add('lp--no-proof');
          return;
        }

        this.setText('[data-lp-body]', '“' + r.body + '”');
        this.setText('[data-lp-name]', r.name);

        const stars = this.querySelector('[data-lp-stars]');
        if (stars) {
          const n = Math.max(1, Math.min(5, Math.round(r.rating || 5)));
          stars.innerHTML =
            '<span class="lp__stars-on">' + '★'.repeat(n) + '</span>' +
            '<span class="lp__stars-off">' + '★'.repeat(5 - n) + '</span>';
        }

        const verified = this.querySelector('[data-lp-verified]');
        if (verified) verified.hidden = !r.verified;
      }
    }
  );
}
